import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * กันไม่ให้เข้าหน้าที่ต้อง login
 *
 * ระหว่างที่ยังไม่รู้สถานะ (isLoading) ต้องแสดงหน้ารอ ห้าม redirect —
 * ไม่งั้นทุกครั้งที่ refresh จะเด้งออกไป /login ชั่วขณะก่อนเด้งกลับ ซึ่งกระพริบน่ารำคาญ
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <div
          className="size-8 animate-spin rounded-full border-2 border-line-strong border-t-up"
          role="status"
          aria-label="กำลังตรวจสอบสถานะการเข้าสู่ระบบ"
        />
      </div>
    );
  }

  if (user === null) {
    // จำหน้าที่ตั้งใจจะไว้ เพื่อพากลับมาหลัง login สำเร็จ
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
